import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toggleSidebar: false,
  scroll: false,
  globalLoader: false, 
};

const LayoutSlice = createSlice({
  name: "LayoutSlice",
  initialState,
  reducers: {
    setToggleSidebar: (state, action) => {
      state.toggleSidebar = action.payload;
    },
    setScrollMenu: (state, action) => {
      state.scroll = action.payload;
    },
    setGlobalLoader: (state, action) => {
      state.globalLoader = action.payload;
    },
  },
});
export const { setToggleSidebar, setScrollMenu, setGlobalLoader } = LayoutSlice.actions;

export default LayoutSlice.reducer;
